"use strict";
/**
 * @packageDocumentation
 * @module BalanceUtils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_FEE = exports.asFemtoKilt = exports.convertToTxUnit = exports.formatKiltBalance = exports.KILT_COIN = void 0;
const tslib_1 = require("tslib");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const util_1 = require("@polkadot/util");
exports.KILT_COIN = new bn_js_1.default(1);
function formatKiltBalance(amount, additionalOptions) {
    const options = Object.assign({ decimals: 15, withSiFull: true, withUnit: 'KILT' }, additionalOptions);
    return util_1.formatBalance(amount, options);
}
exports.formatKiltBalance = formatKiltBalance;
function convertToTxUnit(balance, power) {
    return new bn_js_1.default(balance).mul(new bn_js_1.default(10).pow(new bn_js_1.default(15 + power)));
}
exports.convertToTxUnit = convertToTxUnit;
function asFemtoKilt(balance) {
    return convertToTxUnit(balance, 0);
}
exports.asFemtoKilt = asFemtoKilt;
exports.TRANSACTION_FEE = convertToTxUnit(new bn_js_1.default(125), -9);
exports.default = {
    KILT_COIN: exports.KILT_COIN,
    TRANSACTION_FEE: exports.TRANSACTION_FEE,
    formatKiltBalance,
    asFemtoKilt,
    convertToTxUnit,
};
